import type { ReactNode } from 'react';
import { useTema, type Tema } from '../theme.js';

const OPCOES: Array<{ id: Tema; titulo: string; icone: ReactNode }> = [
  {
    id: 'sistema',
    titulo: 'Seguir o sistema',
    // Meio-a-meio: diz "os dois, conforme o aparelho" sem precisar de texto.
    icone: (
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="5.25" stroke="currentColor" strokeWidth="1.4" />
        <path d="M8 2.75A5.25 5.25 0 0 1 8 13.25z" fill="currentColor" />
      </svg>
    ),
  },
  {
    id: 'claro',
    titulo: 'Tema claro',
    icone: (
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="3.1" stroke="currentColor" strokeWidth="1.4" />
        <path
          d="M8 1.4v1.7M8 12.9v1.7M1.4 8h1.7M12.9 8h1.7M3.4 3.4l1.2 1.2M11.4 11.4l1.2 1.2M12.6 3.4l-1.2 1.2M4.6 11.4l-1.2 1.2"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: 'escuro',
    titulo: 'Tema escuro',
    icone: (
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M13.2 9.9A5.6 5.6 0 0 1 6.1 2.8a5.6 5.6 0 1 0 7.1 7.1z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export function ThemeToggle() {
  const { tema, definir } = useTema();

  return (
    <div
      className="segmented"
      role="group"
      aria-label="Tema da interface"
      style={{ flex: '0 0 auto' }}
    >
      {OPCOES.map((o) => (
        <button
          key={o.id}
          type="button"
          // aria-pressed em vez de aria-current: são três opções exclusivas de
          // aparência, não navegação.
          aria-pressed={tema === o.id}
          aria-label={o.titulo}
          title={o.titulo}
          onClick={() => definir(o.id)}
        >
          {o.icone}
        </button>
      ))}
    </div>
  );
}
